import { EApplicationEnvironments } from '../app/core/configurations/application.config';
import { EApplicationLogLevel } from '../app/shared/models/log.model';

export const environment = {
  application_environment: EApplicationEnvironments.dev,
  client_id: 'spa-my-leasehawk',
  idp_url: 'https://login-dev.leasehawk.com',
  lh_api_url: 'https://internalapi-dev.leasehawk.com',
  reporting_api_url: 'https://reporting-api-dev.leasehawk.com',
  sitemanagement_api_url: 'https://sitemanagement-api-dev.leasehawk.com',
  scorecards_api_url: 'https://scorecards-api-dev.leasehawk.com',
  conversation_api_url: 'https://conversation-api-dev.leasehawk.com',
  agent_call_management_api_url: 'https://agentcallmanagement-api-dev.leasehawk.com',
  reporting_show_error_detail: false,
  show_auth_debug_information: false,
  log_level: EApplicationLogLevel.Error,
  log_endpoint: 'https://internalapi-dev.leasehawk.com/api/LoggingService/LogPost',
  admin_url: 'https://admin-dev.leasehawk.com',
  conversation_viewer_url: 'https://conversation-dev.leasehawk.com',
  elastic_search_url: 'https://dev-txn.es.us-east-1.aws.found.io',
  elastic_search_api_key: 'Qkl1eEdvNEIzUFNFeGZWVVJCRFA6SHVPaDgweVFSaXFWdmR4WUFodTU5dw==',
  graphql_url: 'https://myleasehawk-data-access-gateway-dev.leasehawk.com/graphql',
  ace_vla_url: 'https://acevla-admin-api-dev.leasehawk.com',
};
